import { defineComponent as C, inject as x, computed as f, toRef as I, h as l } from "vue";
import { useRtl as w } from "./ghl-ui.es851.js";
import { collapseInjectionKey as $ } from "./ghl-ui.es170.js";
import P from "./ghl-ui.es943.js";
import b from "./ghl-ui.es854.js";
import { createId as R } from "./ghl-ui.es939.js";
import y from "./ghl-ui.es706.js";
import { throwError as N } from "./ghl-ui.es853.js";
import { happensIn as h } from "./ghl-ui.es944.js";
import { resolveSlotWithProps as v, resolveWrappedSlotWithProps as _ } from "./ghl-ui.es860.js";
import S from "./ghl-ui.es862.js";
import D from "./ghl-ui.es945.js";
import A from "./ghl-ui.es946.js";
const E = {
  title: String,
  name: [String, Number],
  disabled: Boolean,
  displayDirective: String
}, O = C({
  name: "CollapseItem",
  props: E,
  setup(a) {
    const {
      mergedRtlRef: s
    } = b(a), i = R(), t = y(() => {
      var e;
      return (e = a.name) !== null && e !== void 0 ? e : i;
    }), n = x($);
    n || N("collapse-item", "`n-collapse-item` must be placed inside `n-collapse`.");
    const {
      expandedNamesRef: r,
      props: c,
      mergedClsPrefixRef: m,
      slots: d
    } = n, p = f(() => {
      const {
        value: e
      } = r;
      if (Array.isArray(e)) {
        const {
          value: o
        } = t;
        return !~e.findIndex((g) => g === o);
      } else if (e) {
        const {
          value: o
        } = t;
        return o !== e;
      }
      return !0;
    });
    return {
      rtlEnabled: w("Collapse", s, m),
      collapseSlots: d,
      randomName: i,
      mergedClsPrefix: m,
      collapsed: p,
      triggerAreas: I(c, "triggerAreas"),
      mergedDisplayDirective: f(() => {
        const {
          displayDirective: e
        } = a;
        return e || c.displayDirective;
      }),
      arrowPlacement: f(() => c.arrowPlacement),
      handleClick(e) {
        let o = "main";
        h(e, "arrow") && (o = "arrow"), h(e, "extra") && (o = "extra"), c.triggerAreas.includes(o) && n && !a.disabled && n.toggleItem(p.value, t.value, e);
      }
    };
  },
  render() {
    const {
      collapseSlots: a,
      $slots: s,
      arrowPlacement: i,
      collapsed: t,
      mergedDisplayDirective: n,
      mergedClsPrefix: r,
      disabled: c,
      triggerAreas: m
    } = this, d = v(s.header, {
      collapsed: t
    }, () => [this.title]), p = s["header-extra"] || a["header-extra"], u = s.arrow || a.arrow;
    return l("div", {
      class: [`${r}-collapse-item`, `${r}-collapse-item--${i}-arrow-placement`, c && `${r}-collapse-item--disabled`, !t && `${r}-collapse-item--active`, m.map((e) => `${r}-collapse-item--trigger-area-${e}`)]
    }, l("div", {
      class: [`${r}-collapse-item__header`, !t && `${r}-collapse-item__header--active`]
    }, l("div", {
      class: `${r}-collapse-item__header-main`,
      onClick: this.handleClick
    }, i === "right" && d, l("div", {
      class: `${r}-collapse-item-arrow`,
      key: this.rtlEnabled ? 0 : 1,
      "data-arrow": !0
    }, v(u, {
      collapsed: t
    }, () => {
      var e;
      return [l(S, {
        clsPrefix: r
      }, {
        default: (e = a.expandIcon) !== null && e !== void 0 ? e : () => this.rtlEnabled ? l(D, null) : l(A, null)
      })];
    })), i === "left" && d), _(p, {
      collapsed: t
    }, (e) => l("div", {
      class: `${r}-collapse-item__header-extra`,
      onClick: this.handleClick,
      "data-extra": !0
    }, e))), l(P, {
      clsPrefix: r,
      displayDirective: n,
      show: !t
    }, s));
  }
});
export {
  E as collapseItemProps,
  O as default
};
